import { Pipe, PipeTransform } from '@angular/core';
import {TeamRole} from '../models/team-member';

@Pipe({
    name: 'teamMemberRoleTranslate',
    standalone: false
})
export class TeamMemberRoleTranslatePipe implements PipeTransform {

  transform(role: keyof typeof TeamRole): string {
    return TeamRole[role];
  }

}
